import { CoreEvent, eventNames } from '@carvana/core-events';
import LinkButton from '@carvana/ds-link-button';
import { DispatcherEvent } from '@carvana/merch-native';
import NavPayloadAction from '@carvana/merch-native/NavPayloadAction';
import { useIsNative } from '~/context/common/DeviceContext';
import { useSendMessageToNative } from '~/context/common/NativeContext';
import HeartWithBorder from '~/icons/HeartWithBorder';
import HeartWithBorderThin from '~/icons/HeartWithBorderThin';
import { type ToastAction, type ToastView, ToastViews } from './types';

type OwnProps = {
  action: ToastAction;
  view?: ToastView;
};

export default function FavoritesToastContent({
  action,
  view = ToastViews.vehicles
}: OwnProps) {
  const isNative = useIsNative();
  const sendMessageToNative = useSendMessageToNative();

  const isAdding = action === 'add';
  const text = isAdding
    ? 'Added to your favorites'
    : 'Removed from your favorites';

  return (
    <div className="flex w-auto items-center justify-between gap-md t-heading-sm">
      {isAdding ? (
        <HeartWithBorderThin className="h-20 w-20" isFavorited />
      ) : (
        <HeartWithBorder darkGray className="h-16 w-16" />
      )}
      <span className="whitespace-nowrap">{text}</span>
      {isAdding && (
        <LinkButton
          data-analytics-id="Favorites"
          data-analytics-attributes={JSON.stringify({
            description: 'toast view button',
            type: view
          })}
          data-testid="favorites-toast-view"
          size="sm"
          onClick={() => {
            if (isNative) {
              sendMessageToNative(DispatcherEvent.Link, {
                action:
                  view === ToastViews.vehicles
                    ? NavPayloadAction.ViewFavorites
                    : NavPayloadAction.ViewSavedSearches
              });
            } else {
              CoreEvent.emit(eventNames.favorites.mfe.drawer.open, {
                tab: view
              });
            }
          }}
        >
          View
        </LinkButton>
      )}
    </div>
  );
}
